<ng-template #fisaBonitareModal let-modal="close">
  <div class="modal-header">
    <div class="modal-title">Fișa Bonitare</div>

    <div class="btn-group custom-modal-btn">
      <button
        class="btn btn-sm btn-secondary"
        (click)="modal('Cross click')"
        autofocus="false"
      >
        Închide
      </button>
    </div>
  </div>
  <div class="modal-body">
    <div class="container-fluid">
      <form [formGroup]="fisaBonitareForm">
        <div class="row column-gap-5">
          <div class="col-auto">
            <div class="form-group mb-3">
              <label>Data</label>

              <app-date-picker
                [selectedDate]="fisaBonitareForm.value.data"
                (dateChanged)="onDateChanged($event)"
              ></app-date-picker>
            </div>
          </div>

          <div
            *ngIf="isAdmin || isOperator"
            class="col-auto"
          >
            <div class="form-group mb-3">
              <label>Bonitor</label>

              <ng-select
                [items]="bonitori"
                bindLabel="full_name"
                bindValue="id"
                formControlName="bonitor_id"
                placeholder="Alege operatorul"
              >
              </ng-select>
            </div>
          </div>

        </div>
      </form>

      <br /><br />
      <button
        *ngIf="isAdmin || isOperator"
        class="btn btn-lg btn-success"
        (click)="onSubmitted()"
      >
        Descarcă
      </button>
    </div>
  </div>
</ng-template>
